"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomMeta = void 0;
var React = require("react");
var ReliablePartnerStatus_1 = require("components/ReliablePartnerStatus");
var preview_1 = require("utils/preview");
var ListRow_1 = require("views/FileListOverview/FileList/ListRow");
var utils_1 = require("../utils");
var RenderFileLink_1 = require("components/RenderFileLink/RenderFileLink");
var useCustomMeta = function (cols, file, baseUrl, isMobile, token, section) {
    return React.useMemo(function () {
        var elements = [];
        var columnMap = cols.columnMap;
        if (!columnMap) {
            return elements;
        }
        columnMap.forEach(function (column, key) {
            var _a, _b, _c, _d, _e, _f;
            if (column.id === undefined) {
                return;
            }
            var dataKey = '__' + column.id;
            if (column.identifier === 'name-meta' && file.name) {
                elements.push(React.createElement(RenderFileLink_1.RenderFileLink, { key: key, file: file, baseUrl: baseUrl, isMobile: isMobile, token: token, dataKey: dataKey, index: key, createLink: preview_1.createLink, getTarget: ListRow_1.getTarget, section: section }));
                return;
            }
            if (column.identifier === 'description-meta' &&
                ((_a = file.meta) === null || _a === void 0 ? void 0 : _a.reliablePartnerStatus)) {
                elements.push(React.createElement("div", { key: "".concat(key, "-description-meta"), className: 'row__column ' + dataKey },
                    React.createElement(ReliablePartnerStatus_1.ReliablePartnerStatus, { status: (_b = file.meta) === null || _b === void 0 ? void 0 : _b.reliablePartnerStatus, text: (0, ReliablePartnerStatus_1.reliablePartnerStatusText)((_c = file.meta) === null || _c === void 0 ? void 0 : _c.reliablePartnerStatus) })));
                return;
            }
            if (column.identifier === 'added-meta' && ((_d = file.meta) === null || _d === void 0 ? void 0 : _d.created_at)) {
                elements.push(React.createElement("div", { key: "".concat(key, "-size-meta"), "data-length": (_e = file.meta) === null || _e === void 0 ? void 0 : _e.created_at.toString().length, className: 'row__column size ' + dataKey }, file.meta && (0, utils_1.formatDate)(Number(file.meta.created_at))));
                return;
            }
            if (column.identifier === 'added-by-meta') {
                elements.push(React.createElement("div", { key: "".concat(key, "-size-meta"), "data-length": (_f = file.author) === null || _f === void 0 ? void 0 : _f.firstName.toString().length, className: 'row__column size ' + dataKey }, file.author && " ".concat(file.author.firstName, " ").concat(file.author.lastName)));
                return;
            }
            var value = (0, ListRow_1.formatMetadata)(column.identifier, file.customMeta[column.id], column);
            elements.push(React.createElement("div", { "data-length": value.toString().length, key: column.id, className: 'row__column ' + dataKey },
                React.createElement("span", null, value)));
        });
        return elements;
    }, [cols, file, baseUrl, isMobile, token, section]);
};
exports.useCustomMeta = useCustomMeta;
